module.exports = __webpack_public_path__ + "static/media/Me_4.c30159e3.jpeg";